module.exports = __webpack_public_path__ + "fonts/CashSans-Regular.3365cfb.woff2";